import { debounce, call, put, select } from 'redux-saga/effects';

import { ratesSuccess, ratesFailure, ratesRequest } from '../../slices/cruise';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* ratesWorker(action) {
  try {
    const {
      itineraryId,
      adults,
      seniors,
      children,
      lapInfants,
      seatInfants,
      pastPassengerNumber,
      passengerOccupation,
      passengerFirstName,
      passengerMiddleName,
      passengerLastName,
      shipId,
    } = action.payload;
    const { city } = yield select((store) => store.tripSearch.searchObj.cruise.filters);

    const config = {
      method: 'get',
      url: `cruises/getRates?${queryString.stringify(
        {
          itineraryId,
          adults,
          seniors,
          children,
          lapInfants,
          seatInfants,
          passengerCityCode: city ? city.value : null,
          pastPassengerNumber,
          passengerFirstName,
          passengerMiddleName,
          passengerLastName,
          passengerOccupation,
          shipId,
        },
        { skipNull: true },
      )}`,
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(ratesSuccess(response.data));
    } else throw new Error();
  } catch (error) {
    yield put(ratesFailure(error));
  }
}

function* ratesWatcher() {
  yield debounce(50, ratesRequest.toString(), ratesWorker);
}

export default ratesWatcher;
